import { makeObservable, observable } from 'mobx';
import { TReference } from './types';
import { TStreamBlock, TTextStreamBlock } from './components';

export type TDescriberBlock = { type: string; content: string };

export class StreamMessage {
  blocks: TStreamBlock[] = [];
  references: TReference[] = [];
  tables: Record<string, string> = {};
  charts: Record<string, string> = {};
  finished: boolean = true;
  constructor(
    hasStream?: boolean,
    public messageFooter?: string,
    public messageHeader?: string,
  ) {
    makeObservable(this, {
      references: observable,
      blocks: observable,
      tables: observable,
      charts: observable,
      finished: observable,
    });
    hasStream && (this.finished = false);
  }

  addPart<T extends TStreamBlock>(part: T, afterAddPart?: (added: T) => void) {
    if (
      this.blocks.length > 0 &&
      this.blocks[this.blocks.length - 1].blockType === 'text' &&
      part.blockType === 'text'
    ) {
      const aux: TTextStreamBlock = this.blocks[
        this.blocks.length - 1
      ] as TTextStreamBlock;
      if (aux !== part) {
        //aux.str +=
        //  aux.str.length === 0 ? part.str.replace(/^\s+/, '') : part.str;
        aux.str += part.str;
      }
    } else {
      this.blocks.push(part);
    }
    afterAddPart && afterAddPart(part);
  }

  getLastBlock() {
    return this.blocks[this.blocks.length - 1];
  }

  streamFinished() {
    this.finished = true;
  }
}
